import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Concierge from "./sections/Concierge";
import TheLuxuryOfConvenience from "./sections/TheLuxuryOfConvenience";
import FacialBalancing from "./sections/FacialBalancing";
import Expertise from "./sections/Expertise";
import Transformations from "./sections/Transformations";
import Begin from "./sections/Begin";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Concierge />
      <TheLuxuryOfConvenience />
      <FacialBalancing />
      <Expertise />
      <Transformations />
      <Begin />
      <Footer />
    </div>;
}